import { usePartnerAccountsState } from './usePartnerAccountsState';

export function useSupportPartnerAccountsState({ adminFetch }) {
  return usePartnerAccountsState({
    adminFetch,
    endpoint: '/admin/support/partners',
    role: 'support_partner',
    roleLabel: 'Support Partner',
  });
}
